// extracted by mini-css-extract-plugin
module.exports = {"background":"alternated-background-module--background--y5pz6"};